export default __webpack_public_path__ + "static/media/linkedinpfp.172442d3.jpg";